import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { ImportantMessageSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/important-message-svg/important-message-svg.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params , RouterModule } from '@angular/router';
import { BillingDataService } from '../../../../../_services/data-services/billing-data.service';
import { PaymentServiceService } from '../../../../../_services/payment-service/payment-service.service';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, MapfreAlertComponent, ImportantMessageSvgComponent, MapfreButtonComponent],
  selector: 'app-make-payment-error',
  templateUrl: './make-payment-error.component.html',
  styleUrls: ['./make-payment-error.component.scss'],
})
export class MakePaymentErrorComponent implements OnInit {
  policyId: string;
  isAcmic: boolean;
  constructor(
    private router: Router,
    private policyDataService: PolicyDataService,
    private billingDataService: BillingDataService,
    private paymentService: PaymentServiceService,
    private activatedRoute: ActivatedRoute,
    private acmicService: AcmicService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'];
    });
  }

  gotoMakePayment() {
    this.paymentService.clear();
    this.policyDataService.clear();
    this.billingDataService.clearBilling();
    this.billingDataService.clearCheckingAccount();
    this.router.navigate(['/make-payment']);
  }

  goToNewPayment() {
    this.router.navigate(['make-payment', this.policyId, 'new-guest-payment']);
  }
}
